export default {
  methods: {
    onGridReady(agGrid) {
      this.agGrid = agGrid
      agGrid.api.setFilterModel({ 'status.name': { filterType: 'text', type: 'equals', filter: 'P' } })
    }
  }
}
